/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { LoadingSpinnerService } from "./../../../shared/components/loading-spinner/loading-spinner.service";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { LayoutService } from "../../services/layoutservice.service";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { environment } from "src/environments/environment";
import { SsotokenService } from "src/app/shared/services/ssotoken/ssotoken.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  @Output() username = new EventEmitter();
  public persondata = [];
  typePassword: Boolean = false;
  invalid__credential: Boolean = false;
  adminuser__login: Boolean = false;
  userIdInValid = true;
  showErrorText = false;
  errorTextMsg: string;
  landurl: string;
  redirect_url: string;
  model: any = {};
  userdetails = null;
  isProdEnv = false;

  //  togglePassword = false;
  constructor(
    private _layoutService: LayoutService,
    private router: Router,
    private cookieService: CookieService,
    private _loadingSpinnerService: LoadingSpinnerService,
    private _ssotokenService: SsotokenService
  ) {
    this.landurl = environment.land_url;
    this.redirect_url = environment.redirect_url + this.landurl;
    this.isProdEnv = environment.production;
  }

  ngOnInit() {
    localStorage.removeItem("username");
    localStorage.removeItem("userDetails");
    localStorage.clear();
    sessionStorage.clear();
    this._layoutService.logoutDuringLogin();
    document.body.style.overflowY = "auto";
    this._loadingSpinnerService.hide();

    if (this.cookieService.get("PearsonSSOSession")) {
      this._ssotokenService.setSSOToken(
        this.cookieService.get("PearsonSSOSession")
      );
      this.checktokenvalid(this.cookieService.get("PearsonSSOSession"));
    } else {
      this._ssotokenService.setSSOToken(null);
    }
  }

  checktokenvalid(pessosession) {
    this._loadingSpinnerService.show();
    document.body.style.overflow = "hidden";
    this._layoutService.checktokenvalid(pessosession).subscribe(
      (data) => {
        document.body.style.overflowY = "auto";
        this._loadingSpinnerService.hide();
        if (data[0].success == "true") {
          this.showErrorText = false;
          this.userdetails = data;
          if (data && data[0].approvalCode == "APP") {
            //  this.userLoginDetails(data.userId);

            localStorage.setItem("username", data[0].first_name);
            localStorage.setItem("userDetails", JSON.stringify(data[0]));
            localStorage.setItem("notification", "true");
            var u_name = localStorage.getItem("username");
            this._layoutService.newUser(u_name);
            this.router.navigate(["/home"]);
          } else if (data && data[0].approvalCode == "PRG") {
            this.showErrorText = true;
            this.errorTextMsg = "User is Pending for Approval.";
          } else if (data && data[0].approvalCode == "REJ") {
            this.showErrorText = true;
            this.errorTextMsg = "User Approval is Rejected.";
          }
        } else {
          sessionStorage.setItem("regdetail", JSON.stringify(data));
          this.router.navigate(["/register"]);
        }
      },
      (error) => {
        document.body.style.overflowY = "auto";
        this._loadingSpinnerService.hide();
      }
    );
  }

  checkuserexist(userid: string = "test") {
    this.showErrorText = false;
    let userId = this.model.userId.trim();
    this._layoutService.checkuserexist(userId).subscribe(
      (data) => {
        this.userdetails = data;
        if (data && data.success == "true") {
          this.userLoginDetails(userId);
        } else {
          if (data && data.status == "Waiting for approval") {
            this.showErrorText = true;
            this.errorTextMsg = "User is Pending for Approval.";
          } else if (data && data.status == "Rejected") {
            this.showErrorText = true;
            this.errorTextMsg = "User Approval is Rejected.";
          } else {
            this.showErrorText = true;
            this.errorTextMsg = "Please register.";
          }
        }
      },
      (error) => {
        this.invalid__credential = true;
      }
    );
  }

  userLoginDetails(loginId: string) {
    this._layoutService.getUserDetails(loginId).subscribe(
      (res) => {
        localStorage.setItem("username", res[0].first_name);
        localStorage.setItem("userDetails", JSON.stringify(res[0]));
        localStorage.setItem("notification", "true");
        var u_name = localStorage.getItem("username");
        this._layoutService.newUser(u_name);
        this.router.navigate(["/home"]);
      },
      (error) => {
        this.router.navigate(["./error"]);
      }
    );
  }

  togglePassword() {
    this.typePassword = !this.typePassword;
  }

  adminuser_login() {
    this.adminuser__login = true;
  }

  enableLoginBtn(userId: string) {
    this.showErrorText = false;
    this.userIdInValid = true;
    if (userId && userId.trim().length > 3) {
      this.userIdInValid = false;
    }
  }

  closeModal() {
    this.showErrorText = false;
    this.router.navigate(["/login"]);
  }
}
